import { render } from "./Foot.vue?vue&type=template&id=773bd9f8"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"
script.render = render

export default script